module.exports = __webpack_public_path__ + "static/threepackfloralbib-b8253e266310fcf8119ff435dc9b68c0.jpeg";